import './style.scss';

const lpcbRichTableScrollHint = () => {
    const tables = document.querySelectorAll('.lpcb-rich-table--scrollable');

    tables.forEach(table => {
        let isHintDismissed = false;

        const updateHint = () => {
            const hasScrollableWidth = table.scrollWidth > table.clientWidth + 1;
            if (table.scrollLeft > 10) {
                isHintDismissed = true;
            }

            table.classList.toggle('has-scroll-hint', hasScrollableWidth);
            table.classList.toggle('is-scroll-hint-hidden', !hasScrollableWidth || isHintDismissed);
        };

        updateHint();

        table.addEventListener('scroll', updateHint, { passive: true });
        window.addEventListener('resize', updateHint);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lpcbRichTableScrollHint);
} else {
    lpcbRichTableScrollHint();
}
